module.exports = __webpack_public_path__ + "media/images/project/plus-f9a1907765bca1640dc4957d9a725f74.svg";